import { decimalSeparator, minorToDecimalString, parseAmount, type NumberLocale } from '@koverta/shared';

/** Keypad raw value: major units as typed, '.' as the decimal point ("8000", "24.5"). */
export const rawToMinor = (raw: string) => (raw ? (parseAmount(raw.replace(/\.$/, ''), 'en') ?? 0) : 0);
/** Minor units → raw keypad value, always with two decimals: 245000 → "2450.00". */
export const minorToRaw = (minor: number) => minorToDecimalString(Math.abs(minor));

export function pressKey(raw: string, key: string, maxDigits = 9): string {
  if (key === '⌫') return raw.slice(0, -1);
  if (key === '.') return raw.includes('.') ? raw : (raw || '0') + '.';
  if (raw.includes('.') && raw.split('.')[1]!.length >= 2) return raw;
  const next = (raw === '0' ? '' : raw) + key;
  return next.replace('.', '').length > maxDigits ? raw : next;
}

/** 3×4 numeric keypad (design-system §6): 1–9, then the locale decimal, 0, ⌫. */
export function Keypad({
  raw,
  onChange,
  locale,
}: {
  raw: string;
  onChange: (raw: string) => void;
  locale: NumberLocale;
}) {
  const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0', '⌫'];
  return (
    <div className="kp">
      {keys.map((k) => (
        <button
          key={k}
          type="button"
          onClick={() => onChange(pressKey(raw, k))}
          aria-label={k === '⌫' ? 'Delete' : k === '.' ? 'Decimal separator' : k}
        >
          {k === '.' ? decimalSeparator(locale) : k}
        </button>
      ))}
    </div>
  );
}
